




    import { Vue, Component, Prop } from 'vue-property-decorator';
    import { toViewport } from "@common/scrollerHelper";
    import { serverLink } from "@common/serverLink";
    import { getBackend } from '@service/router/getters';
	import { getBaseUrl } from '@api/helpers/url/baseUrl';

    @Component({ name: "Form" })
    export default class Form extends Vue {
        @Prop({required: true}) formId: string;

        frameLoaded() {
            if (this.$refs['form-frame']) {
                const sessionData = {
                    type: 'session',
                    session: this.generateSession()
                };
                (this.$refs['form-frame'] as HTMLIFrameElement).contentWindow?.postMessage(sessionData, '*');
                window.addEventListener('message', this.messageFromIframe);
                setTimeout(
                    () => {
                        toViewport(this.$refs['form-frame']as HTMLElement);
                    }, 350
                )

            }
        }

        messageFromIframe(event: MessageEvent) {
            if (event.data) {
                try {
                    const data = JSON.parse(event.data);
                    if (data.from && data.from == 'forms' && data?.formId == this.formId) {
                        if (data.height) {
                            this.$refs['form-frame'] && ((this.$refs['form-frame'] as HTMLElement).style.height = (data.height + 10) + 'px');
                        }
                    }
                }
                catch (e) {
                    //data is not json
                }
            }
        }

        generateSession() {
            return {
                sessionId: this.$store.state.session.sessionId,
                backendUrl: getBaseUrl(this.$store.state.session.backend),
                baseUrl: serverLink(),
                projectName:  getBackend(this.$route.params.backend),
                refreshToken: this.$store.state.session.refreshToken,
                userId: this.$store.state.session.userId,
                language: this.$store.state.session.language,
                colorScheme: {
                    accent: "#337DF6"
                }
            }
        }

        get link() {
            const backend = getBackend(this.$route.params.backend);
            return `https://static.appercode.com/forms/?formId=${this.formId}&amp;project=${backend}` +
                `&amp;lang=${this.$store.state.session.language}&amp;server=${serverLink(getBaseUrl(backend))}`
        }
    }
